export const environment = {
    production: false,
    auth: {
        clientID: 'C4MCcjTKahTJN5oBc7I7DkdPVJzDv4VE',
        audience: 'https://media.ra.dev',
        domain: 'ra-media.auth0.com',
        algorithm: 'RSA256',
        responseType: 'token id_token',
        scope: 'openid profile email'
    },
    api: 'https://api-phoenix-uat.media-uat.revenueanalytics.io',
    sfOpportunityUrl: 'https://pandora--pandora1.lightning.force.com/lightning/r/Opportunity/OPPORTUNITY_ID/view'
};
